import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { userConfigList, deleuserConfig } from "@/api/pakgConfig/userConfig";
import addUserlistConfigs from "./components/addUserlistConfig";
import { serchSelect } from "@/mixins/index";
export default {
  name: "userlistPakgConfig",
  components: {
    addUserlistConfigs: addUserlistConfigs
  },
  mixins: [serchSelect],
  data: function data() {
    return {
      reqLoading: false,
      minWidth: 200,
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      tableTitle: [],
      gameId: "",
      value1: "",
      total: 0,
      pagrSize: 10,
      disabled: true,
      sels: [],
      selsString: "",
      addUserlistConfigs: false,
      searchData: {
        page: 1,
        pages_size: 10,
        game: "",
        platform: "",
        channel: "",
        pkg: ""
      },
      showing: false,
      tableData: []
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.kind = 1;
      this.reqLoading = true;
      this.searchData.page = e;
      userConfigList(this.searchData).then(function (res) {
        if (res.status == 200) {
          var list = ['n_game', 'n_platform', 'n_channel', 'n_pkg', 'o_game', 'o_platform', 'o_channel', 'o_pkg'];
          _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
          _this.total = res.data.total - 0 || 0;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this2.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleSource: function handleSource(id) {
      var _this3 = this;

      this.addUserlistConfigs = true;
      this.showing = true;
      this.$nextTick(function () {
        _this3.$refs.addUserlistConfigs.init(id);
      });
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm("此操作将删除该配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleuserConfig({
                  id: id
                }).then(function (res) {
                  _this4.searchClick(_this4.searchData.page);
                });

                _this4.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};